import React from "react";
import TodayDate from "../Date/TodayDate";

const BottomHeader = () => {
  return (
      <TodayDate />
  );
};

export default BottomHeader;
